import { render, staticRenderFns } from "./Fec.vue?vue&type=template&id=4c73062e&scoped=true&"
import script from "./Fec.vue?vue&type=script&lang=ts&"
export * from "./Fec.vue?vue&type=script&lang=ts&"
import style0 from "./Fec.vue?vue&type=style&index=0&id=4c73062e&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4c73062e",
  null
  
)

export default component.exports